import ApiService from "@Src/services/ApiService";
import { SUBSCRIPTION_REQUEST_API_ROUTES } from "./SubscriptionRequest.api.constant";

export async function getInstituteTypes() {
    return await ApiService.fetchData({
        url:SUBSCRIPTION_REQUEST_API_ROUTES.GET_INSTITUTE_TYPE,
        method: "GET",
        params: ''
    });
}

export async function postSubscriptionRequest(payload:any) {
    return await ApiService.fetchData({
        url:SUBSCRIPTION_REQUEST_API_ROUTES.SEND_SUBSCRIPTION_REQUEST,
        method: "POST",
        data:payload
    });
}
